import { useFontStyles, useResetStyles } from './theme';

export function GlobalStyles() {
  useFontStyles();
  useResetStyles();

  return null;
}
